import { gql } from '@apollo/client';

import { ctaFragment } from '../../../../components/CallToAction/query';
import type { CallToActionDataProps } from '../../../../components/CallToAction/types';
import type { ContentfulSysProps } from '../../../../types/contentful';
import type { Items } from '../../../../types/Items';
import { contentfulSysIdFragment } from '../../../../utils/contentful/contentfulQuery';
import type { ArDownloadLinkCardDataProps } from '../ArDownloadLinkCard/arDownloadLinkCardQuery';
import { arDownloadLinkCardFragment } from '../ArDownloadLinkCard/arDownloadLinkCardQuery';

export interface ArLinkOutsBlockQuery {
  arLinkOutsBlock: ArLinkOutsBlockDataProps;
}

export interface ArLinkOutsBlockDataProps extends ContentfulSysProps {
  contentfulDescription: string;
  backgroundColor?: string;
  ctaColor?: string;
  linksCollection?: {
    items: ArDownloadLinkCardDataProps[];
  };
  callsToActionCollection: Items<CallToActionDataProps>;
}

export const arLinkOutsBlockFragment = {
  all: gql`
    fragment ArLinkOutsBlockAll on ArLinkOutsBlock {
      ...ContentfulSysId
      contentfulDescription
      backgroundColor
      ctaColor
      linksCollection {
        items {
          ...ArDownloadLinkCardAll
        }
      }
      callsToActionCollection {
        items {
          ... on CallToAction {
            ...CallToActionAll
          }
        }
      }
    }
    ${contentfulSysIdFragment}
    ${arDownloadLinkCardFragment.all}
    ${ctaFragment}
  `,
};

export const query = gql`
  query ArLinkOutsBlockQuery($id: String!, $preview: Boolean!, $locale: String!) {
    arLinkOutsBlock(id: $id, preview: $preview, locale: $locale) {
      ...ArLinkOutsBlockAll
    }
  }
  ${arLinkOutsBlockFragment.all}
`;
